import { createRef, useEffect, useState } from 'react';
import styles from './Slider.module.css';

const Slider = ({ value, onChange, min = 1, max = 100, disabled=false, color }) => {
  const container = createRef(null);
  const sliderValue = createRef();
  const [active, setActive] = useState(false);
  const changeHandler = (e) => {
    onChange(e.target.value);
    sliderValue.current.style.transform = 'translateX(-80%)';
    const newVal = Number(((e.target.value - min) * 100) / (max - min));
    sliderValue.current.style.left = `calc(${newVal}% + (${12 - newVal * 0.01}px))`;
  }

  useEffect(() => {
    const eventHandler = (e) => {
      switch(e.type){
        case 'touchstart':
          return setActive(true);
        case 'touchend':
          return setActive(false);
        case 'mousedown':
          return setActive(true);
        case 'mouseup':
          return setActive(false);
      }
    }

    container.current.addEventListener('touchstart', eventHandler);
    container.current.addEventListener('touchend', eventHandler);
    container.current.addEventListener('mousedown', eventHandler);
    container.current.addEventListener('mouseup', eventHandler);
  })
  
  const generateClass = (color) => {
    switch(color){
      case 'blue':
        return styles.calcSliderBlue;
      case 'yellow':
        return styles.calcSliderYellow;
      case 'green':
        return styles.calcSliderGreen;
      default:
        return styles.calcSlider;
    }
  }

  return (
    <div className={styles.sliderContainer}>
      <input ref={container} className={`${generateClass(color)}`} type="range" onChange={changeHandler} min={min} max={max} value={value} disabled={disabled} />
      <div className={styles.sliderValue}><div className={styles.sliderSubcontainer} ><h4 ref={sliderValue} className={!active ? styles.inactive : ''}>{value}<span></span></h4></div></div>
    </div>
  )
}

export default Slider;
